module.exports = __webpack_public_path__ + "img/FR13580.eb9f8254.png";